// config-budget-ceilings.ts
//
// 06g R5 (audit M2, debate D1): a mission ALWAYS runs under an attempt
// ceiling (schema default 60). 3.38.1 (owner decision 2026-10-14): the USD
// ceiling `max_cost_usd_per_mission` is OPTIONAL with NO default — absent ⇒
// no USD ceiling; present ⇒ still > 0. One place for the default, the
// sentence the schema returns for `0`/negative, and the "is there a USD
// ceiling" predicate — imported by config-schema.ts, the status readers and
// the cost consumers (DRY). Kept out of config-schema.ts for its 200-line budget.
export const DEFAULT_MAX_ATTEMPTS_PER_MISSION = 60;
export const BUDGET_CEILING_MUST_BE_POSITIVE =
  "phải > 0 — 0 = không giới hạn không còn được chấp nhận (muốn bỏ trần USD: xoá key max_cost_usd_per_mission; trần attempt mặc định 60)";

/**
 * The USD ceiling a mission actually runs under, or undefined when there is
 * none. `null`/absent = no key configured; a non-positive number can only come
 * from a pre-06g effective-config snapshot (the schema refuses it) and reads
 * as "no ceiling" too.
 */
export function usdCeilingOrUndefined(value: number | null | undefined): number | undefined {
  return typeof value === "number" && value > 0 ? value : undefined;
}
